import React from 'react';
import List from 'pages/Orders/List';

const AllList = ({ ...props}) => (
  <List
    url={"orders"}
    title="All Orders"
    showCompletedAt={true}
    canAssign={true}
    showOrderStatus={true}
    canManage={true}
    canView={true}
    {...props}
  />
);

export default AllList;


// WEBPACK FOOTER //
// ./src/pages/Orders/AllList.jsx